import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoginLoadingService {
  public readonly loginLoading = signal<boolean | null>(null);

  public setLoginLoading(value: boolean): void {
    this.loginLoading.set(value);
  }
}
